import { Mutex } from 'async-mutex';
export class TimeCachedValueControl {
    static TIME_TO_INTERVAL_MS = 20_000;
    static TIME_TO_CACHE_OVERWRITE_MS = null;
}
const DEFAULT_OPTIONS = {
    expirationTime: 'default',
};
export class TimeCachedValue extends TimeCachedValueControl {
    func;
    mutex = new Mutex();
    isCached = false;
    value = undefined;
    options;
    timeoutId = undefined;
    constructor(func, options = {}) {
        super();
        this.func = func;
        this.options = {
            ...DEFAULT_OPTIONS,
            ...options,
        };
    }
    get = async () => {
        if (this.isCached) {
            return this.runCached();
        }
        while (!this.isCached) {
            if (this.mutex.isLocked()) {
                await this.mutex.waitForUnlock();
            }
            else {
                await this.mutex.runExclusive(this.doRefresh);
            }
        }
        return this.value;
    };
    /** Returns the cached value, if any, without computing it. */
    peek = () => (this.isCached ? this.value : undefined);
    prefetch = () => {
        void this.get().catch(() => { });
    };
    refresh = async () => {
        this.reset();
        return this.get();
    };
    reset = () => {
        this.clearTimeout();
        this.value = undefined;
        this.isCached = false;
    };
    runCached = async () => {
        if (this.options.cachedOperation) {
            if (this.mutex.isLocked()) {
                await this.mutex.waitForUnlock();
            }
            await this.mutex.runExclusive(this.options.cachedOperation);
        }
        return this.value;
    };
    clearTimeout() {
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
    }
    doRefresh = async () => {
        this.clearTimeout();
        const value = await this.func();
        this.value = value;
        this.isCached = true;
        if (this.options.expirationTime === 'neverExpire') {
            return;
        }
        const expiration = this.options.expirationTime === 'default'
            ? this.getDefaultExpirationTime()
            : this.options.expirationTime;
        this.timeoutId = setTimeout(this.reset, expiration);
    };
    getDefaultExpirationTime() {
        return (TimeCachedValueControl.TIME_TO_CACHE_OVERWRITE_MS ??
            TimeCachedValueControl.TIME_TO_INTERVAL_MS);
    }
}
